export default __webpack_public_path__ + "static/media/artificial-nails.a15ccbcb.jpg";